import { GoogleOAuthProvider } from "@react-oauth/google";
import { GoogleSignInToggle } from "./GoogleSignInToggle";
import { OwcButton } from "@one/react";
import { react18WorkaroundProps } from "../../utils/constants/constants";

const REACT_APP_GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
type GoogleAuthProps = {
  showCalendarIcon?: boolean;
};

export const GoogleAuth = ({ showCalendarIcon }: GoogleAuthProps) => {
  if (!REACT_APP_GOOGLE_CLIENT_ID) {
    console.error("REACT_APP_GOOGLE_CLIENT_ID is not set");
    return (
      <OwcButton disabled {...react18WorkaroundProps}>
        No Google auth client ID error
      </OwcButton>
    );
  }

  return (
    <GoogleOAuthProvider clientId={REACT_APP_GOOGLE_CLIENT_ID}>
      <GoogleSignInToggle showCalendarIcon={showCalendarIcon} />
    </GoogleOAuthProvider>
  );
};
